const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {
			ZZ1: {
				name: ['出勤', 'Attendance hours', '出勤'],
				children: {
					ZZ_YUSEN_MANAGER_CARDDATA: {
						name: ['(客製)出勤紀錄表', '(客製)出勤紀錄表', '(客製)出勤紀錄表'],
						url: '/zz_yusen_manager_carddata',
						hint: [],
					},
				},
			},
		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
};